import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useUser } from "../context/UserContext";
import { API_ENDPOINTS } from "../api/endpoints";

import ImgCover from "../assets/images/undraw_secure_login_pdn4.svg";
import Logo from "../assets/images/preload.png";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { reloadUser } = useUser(); // <- importante

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setError("Por favor, completa ambos campos.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch(API_ENDPOINTS.externa.authenticate, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        Cookies.set("token", data.secret, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });

        Cookies.set("userId", data.user.id, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });

        Cookies.set("userName", data.user.name, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });

        await reloadUser(); // <- esperar datos antes de continuar
        navigate("/router");
      } else {
        setError(data.messages?.[0] || "Credenciales incorrectas");
      }
    } catch (err) {
      console.error("Error durante la autenticación", err);
      setError("Hubo un problema con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column justify-content-center min-vh-100">
      <div className="page page-center">
        <div className="container container-normal py-4">
          <div className="row align-items-center g-4">
            <div className="col-lg">
              <div className="container-tight">
                <div className="text-center mb-4">
                  <img className="mb-4" src={Logo} width={"10%"} alt="Logo" />
                  <span className="font-ecotrans">
                    <span style={{ fontSize: "40px", color: "#6c9e3c" }}>Eco</span>
                    <span style={{ fontSize: "40px", color: "#3c4442" }}>trans</span>
                  </span>
                </div>
                <div className="card card-md">
                  <div className="card-body">
                    <h2 className="h2 text-center mb-4">Iniciar sesión</h2>
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <input type="text" className="form-control" placeholder="Ingresa tu usuario" value={username} onChange={(e) => setUsername(e.target.value)} />
                      </div>
                      <div className="mb-2">
                        <input type="password" className="form-control" placeholder="Ingresa tu contraseña" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="off" />
                      </div>
                      <div className="form-footer">
                        <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                          {loading ? "Cargando..." : "Iniciar sesión"}
                        </button>
                      </div>
                    </form>
                    {error && <p className="text-danger mt-3">{error}</p>}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg d-none d-lg-block">
              <img src={ImgCover} height="300" className="d-block mx-auto" alt="Login illustration" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
